













import { IFormTemplate } from '@/models';

import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'FormBuilderStatusDisplay',

  props: {
    formTemplate: {
      type: Object as PropType<IFormTemplate>,
      required: true
    }
  }
});
